const LocationInstruction = () => {
    return(
        <>
            <div className="LocationInstruction">
                <h3>Please enable your location!</h3>
                <div className="item">
                    <p className="titleOfDevice"><i className="fa-brands fa-apple"></i> iPhone "iOS"</p>
                    <ul>
                        <li>1.	Open the Settings app on your iPhone.</li>
                        <li>2.	Scroll down and tap on Privacy & Security.</li>
                        <li>3.	Tap Location Services.</li>
                        <li>4.	Make sure Location Services are enabled (the toggle should be green).</li>
                        <li>5.	Scroll down and find Telegram in the list of apps.</li>
                        <li>6.	Tap on Telegram.</li>
                        <li>7.	Select While Using the App or Always to allow Telegram to access your location.</li>
                    </ul>
                    <p>Tip: Choosing “Always” allows sharing live location even when Telegram is in the background.</p>
                </div>
                <div className="item">
                    <p className="titleOfDevice"><i className="fa-brands fa-android"></i> On Android</p>
                    <ul>
                        <li>1.  Open the Settings app on your Android device.</li>
                        <li>2.  Tap Apps (or Apps & notifications, depending on your phone).</li>
                        <li>3.  Find and select Telegram from the app list.</li>
                        <li>4.  Tap Permissions.</li>
                        <li>5.  Tap Location.</li>
                        <li>6.  Choose Allow only while using the app or Allow all the time, depending on your needs.</li>
                    </ul>
                    <p>Tip: “Allow all the time” is needed if you want to share your live location continuously.</p>
                </div>
            </div>
        </>
    )
}

export default LocationInstruction;